import { HintData, MessageData } from '@/interfaces/chat';
import emitter from '../../emitter';
import { HintEventActions, KickEventActions, PreviewEventActions } from '../events';
import { clearAuthCookies, getToken } from '@/utils';
import { Alert } from '@/components/ui/alert-dialog';
import {
  PreviewData,
  PreviewEventData,
  PreviewKnowledgeData,
  PreviewMessageData,
} from '@/interfaces/preview';

function messageHandler(data: MessageData) {
  emitter.emit('MESSAGE', data);
}
function hintHandler(data: HintData) {
  emitter.emit('HINT', data);
  emitter.emit(data.action, data);
}

function previewHandler(
  data: PreviewData | PreviewMessageData | PreviewKnowledgeData | PreviewEventData,
) {
  emitter.emit('PREVIEW', data);
  emitter.emit(data.action, data);
}

function kickHandler(data: any) {
  if (data.action === KickEventActions.KICK_BY_PASSWORD_UPDATED) {
    clearAuthCookies();
    window.location.href = '/login';
    return;
  }

  if (data.attendee && data.attendee === getToken()) {
    return;
  }

  Alert.confirm({
    title: '下线通知',
    description: '抱歉，您的账号已于其他电脑登录，您将被强制下线。',
    confirmText: '知道了',
    hideCancel: true,
    onConfirm: () => {
      clearAuthCookies();
      window.location.href = '/login';
    },
  });
}

// 创建处理器映射的工具函数
const createHandlerMap = <T extends string, D = any>(
  types: Record<string, T>,
  handler: (data: D) => void,
): Record<T, (data: D) => void> => {
  return Object.values(types).reduce(
    (res, type) => {
      res[type] = handler;
      return res;
    },
    {} as Record<T, (data: D) => void>,
  );
};

export default {
  message: messageHandler,
  ...createHandlerMap(PreviewEventActions, previewHandler),
  ...createHandlerMap(KickEventActions, kickHandler),
  ...createHandlerMap(HintEventActions, hintHandler),
} as Record<string, (data: any) => void>;
